import {
  Component,
  Input, Output, EventEmitter,
  ViewChildren, QueryList, ElementRef,
} from '@angular/core';
import * as _ from 'lodash';

import { ActiveFilterModel } from './active-filter.model';
import {
  VEHICLE_FILTER_TYPE, LIST_FILTER_TYPE, PART_ATTRIBUTES_FILTER_TYPE, VCDB_FILTER_TYPE,
} from './active-filter-types';
import { getFilterTitle, getFilterLabel } from './active-filters.helpers';


@Component({
  moduleId: module.id,
  selector: 'active-filters',
  templateUrl: 'active-filters.component.html',
  styleUrls: ['active-filters.component.scss'],
})
export class ActiveFiltersComponent {
  actualWidth: number;
  hiddenCount: number = 0;
  moreWidth: number = 90;
  filterMarginRight: number = 13;

  @Input() filters: Array<any> = [];
  @Input() minimized: boolean = false;
  @Input() isVersion2: boolean = false;
  @Input() isSmallFilters: boolean = false;
  @Input() filtersColor: string = '';
  @Input() ghostValue: string = 'active-filter';
  @Input() maxWidth: number; // for show '+N More'

  @Output() filtersAmountClick: EventEmitter<any> = new EventEmitter();
  @Output() removeFilterItem: EventEmitter<any> = new EventEmitter();
  @Output() hiddenCountChange: EventEmitter<any> = new EventEmitter();

  @ViewChildren('activeFilterItem') activeFilterItems: QueryList<ElementRef>;

  constructor(private el: ElementRef) {}

  get activeFilterItemsDataList(): Array<any> {
    const activeFilterItems = this.el.nativeElement.getElementsByClassName('filter-item');
    if (activeFilterItems.length) {
      return _.map(activeFilterItems, (item , index) => {

        const type = item.getAttribute('type');
        return {
          type,
          width: item.offsetWidth + this.filterMarginRight, // add extra space
        };
      });
    }
    return null;
  }

  getFilterGhostAttr(filter: ActiveFilterModel): string {
    switch (filter.type) {
      case VEHICLE_FILTER_TYPE:
      case VCDB_FILTER_TYPE:
        return _.reduce(_.get(filter, 'data.options'), (memo: string, _filter: any) => {
          return memo + `-${_filter.option}`;
        }, `${this.ghostValue}-${filter.type}-filter`);
      case PART_ATTRIBUTES_FILTER_TYPE:
        let ghostValue = `${this.ghostValue}-${filter.type}-filter`;
        if (filter.data) {
          if (filter.data.attribute_name) { ghostValue = `${ghostValue}-${filter.data.attribute_name}`; }
          if (_.get(filter, 'data.langValue')) { ghostValue = `${ghostValue}-${filter.data.langValue}`; }
          if (_.get(filter, 'data.selectValue')) { ghostValue = `${ghostValue}-${filter.data.selectValue}`; }
          if (_.get(filter, 'data.textValue')) { ghostValue = `${ghostValue}-${filter.data.textValue}`; }
          if (_.get(filter, 'data.dateFromValue')) { ghostValue = `${ghostValue}-from-${filter.data.dateFromValue}`; }
          if (_.get(filter, 'data.dateToValue')) { ghostValue = `${ghostValue}-to-${filter.data.dateToValue}`; }
          if (filter.data.nestedAttributes && filter.data.nestedAttributes.length) {
            _.each(filter.data.nestedAttributes, (nestedAttr: any, i: number) => {
              if (nestedAttr.attributeName) { ghostValue = `${ghostValue}-${nestedAttr.attributeName}`; }
              // if it's last element && 'is null' is checked
              if (i === filter.data.nestedAttributes.length - 1 && filter.data.checkNullValue) {
                ghostValue = `${ghostValue}-empty`;
              } else if (nestedAttr.selectValue) {
                ghostValue = `${ghostValue}-${nestedAttr.selectValue}`;
              }
            });
          }
          // if 'is null' is checked
          if (filter.data.checkNullValue &&
            (!filter.data.nestedAttributes || !filter.data.nestedAttributes.length)) {
            ghostValue = `${ghostValue}-empty`;
          }
        }
        return ghostValue;
      default:
        return `${this.ghostValue}-${filter.type}-filter-${filter._id}`;
    }
  }

  public getFilterTitle(filter: any) {
    // if filter has title then return it, otherwise try to find it in the filter data
    return _.get(filter, 'title') || getFilterTitle(filter);
  }

  public getFilterLabel(filter: any) {
    return getFilterLabel(filter);
  }

  // handlers:
  onRemoveFilterItemClick(filter: ActiveFilterModel) {
    _.pull(this.filters, filter);
    this.removeFilterItem.emit(filter);
  }

  onFiltersAmountClick() {
    this.filtersAmountClick.emit();
  }

}
